import { RiskScoreType } from '@/components/9_TradingRiskScore/types'; // Import RiskScoreType as a value
import { RouteUrlList } from '@/libs/RouteList';

const TradingRiskScoreViewData = [
    'POST',
    RouteUrlList.API_TradingRiskScoreViewData.path,
    {},
    200,
    {
        status: true,
        title: 'Success',
        message: 'Success',
        errorCode: '0000',
        result: {
            tradingRiskScoreCheckbox: [
                {
                    index: 0,
                    question: '',
                    answer: null, // 使用 RiskScoreType.A
                    errorMsg: null
                },
                {
                    index: 1,
                    question: '',
                    answer: null, // 使用 RiskScoreType.B
                    errorMsg: null
                },
                {
                    index: 2,
                    question: '',
                    answer: null, // 使用 RiskScoreType.C
                    errorMsg: null
                },
                {
                    index: 3,
                    question: null,
                    answer: null, // 使用 RiskScoreType.C
                    errorMsg: null
                }
            ],
            financialProduct: ['股票', '基金', '黃金']
        }
    }
];
export default TradingRiskScoreViewData;
